export const iconFontAwesomeSecurityGun = (
	<i className="fa-solid fa-gun"></i>
);
